import { useSearchParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function useLaboratoryTab(canUsePrimoLab: boolean) {
  const [params, setParams] = useSearchParams()
  const tab = !canUsePrimoLab || params.get('lab') === 'external' ? 'external' : 'primolab'
  const setTab = (value: string) => {
    const next = new URLSearchParams(params)
    if (value === 'external') next.set('lab', 'external')
    else next.delete('lab')
    setParams(next)
  }
  return { tab, setTab }
}

export function LaboratoryTabs({ value, onChange, primoLab, external }: {
  value: string; onChange: (value: string) => void; primoLab: boolean; external: boolean
}) {
  return (
    <div role="group" aria-label="Laboratorio" className="flex flex-wrap gap-2 border-b border-gray-200 pb-3">
      {primoLab && <Button size="sm" variant={value === 'primolab' ? 'secondary' : 'ghost'} aria-pressed={value === 'primolab'} onClick={() => onChange('primolab')}>PrimoLab</Button>}
      {external && <Button size="sm" variant={value === 'external' ? 'secondary' : 'ghost'} aria-pressed={value === 'external'} onClick={() => onChange('external')}>Laboratori esterni</Button>}
    </div>
  )
}
